'use client';

import { AccordionProps, Accordion as NGGAccordion } from '@ngg/components';
import Icon from '@ui/components/icon/icon';
import { cn } from '@ngg/storefront-utils';

type AccordionIconProps = {
  open: boolean;
};

const AccordionIcon = ({ open }: AccordionIconProps) => (
  <span>{<Icon name={open ? 'minus' : 'plus'} className="text-base" />}</span>
);

export default function Accordion({ children, ...props }: AccordionProps) {
  return (
    <NGGAccordion
      {...props}
      IconComponent={AccordionIcon}
      WrapperComponent="div"
      classNames={{
        wrapper: cn(
          'ngg-accordion border-borderColor border-b',
          props.classNames?.wrapper,
        ),
        button: cn(
          'text-left items-center leading-4 font-sans font-bold',
          'py-6 pl-0 pr-1 md:px-3',
          props.classNames?.button,
        ),
        panel: cn('pb-5 pt-0 pl-0 pr-1 md:px-3 -mt-2', props.classNames?.panel),
      }}>
      {children}
    </NGGAccordion>
  );
}
